import React, {useState} from 'react';
import {Typography, withStyles} from "@material-ui/core";
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import CustomerGrid from "../../components/Customers/CustomerGrid";
import Toolbar from "../../components/Toolbar/Toolbar";
import Table from "@material-ui/core/Table/Table";
import Grid from "@material-ui/core/Grid/Grid";
import axios from "axios/index";
import MediaSearchField from "../../components/Media/SearchField";

import {
    withPaginator,
    Pagination
} from '../../components/Pagination';

const CustomersIndex = ({_user, classes, items}) => {
    // debugger;
    const [boards, setBoards] = useState(items);
    const [paginate, setPaginate] = useState(true);
    const CancelToken = axios.CancelToken;
    let cancel;

    const doSearch = (searchString) => {
        cancel && cancel();

        axios.get('/search-board', {params: {'query': searchString}, cancelToken: new CancelToken(function executor(c) {cancel = c;})}).then((response) => {
            setPaginate(false);
            if (response.data && response.data.length > 0) {
                setBoards(response.data.map(item => item.entity));
            } else {
                setBoards([]);
            }
        })
    }

    const uploadFile = (e) => {
        const formData = new FormData(); 
        formData.append('file', e.target.files[0]);

        axios.post("customers/import", formData).then(() => {
            swal({
                icon: "success",
                title: i18n.get('customers.import_success'),
                text: i18n.get('contacts.you_will_be_redirected'),
                timer: 4000,
            }).then(() => {
                window.location.reload();
            })
        }).catch(() => {
            swal({
                icon: "error",
                title: i18n.get('contacts.ajax_error'),
            })
        })
    }

    return (
        <Layout>
            {_user.roles[0].name !== 'technician' && (
                <React.Fragment>
                    <Toolbar
                        disableGutters
                        title={i18n.get('boards.heading_board')}
                        items={[
                            {
                                icon: 'add',
                                text: i18n.get('boards.new_board'),
                                href: `/customers/create`,
                            }
                        ]}
                    />
                    <Grid item xs={3}>
                    <Typography>Import Customers from CSV</Typography>
                        <input type="file" onChange={uploadFile} /> 
                    </Grid>
                </React.Fragment>
            )
            }
            {_user.roles[0].name === 'technician' &&
            <Toolbar
                disableGutters
                title={i18n.get('boards.heading_board')}
            />
            }

            {boards.last_page}

            <Grid container justify="space-between" alignItems="center">
                <Grid item xs={3}>
                    <MediaSearchField
                        searchByTyping={true}
                        doSearch={doSearch}
                        label={i18n.get('default.search_board')}
                    />
                </Grid>
                <Grid item xs={3}>
                    {paginate && (
                        <Table>
                            <Pagination
                                colSpan={0}
                            />
                        </Table>
                    )}
                </Grid>
            </Grid>

            <CustomerGrid boards={boards} role={_user.roles[0].name}/>

            {paginate &&
            <Table>
                <Pagination
                    colSpan={1}
                />
            </Table>
            }
        </Layout>
    )
};

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(withPaginator('boards')(CustomersIndex));



// WEBPACK FOOTER //
// ./resources/assets/js/pages/customers/Index.jsx